import { Button } from '@/components/ui/button'

const EmptyState = ({ onRefresh }) => {
    return (
        <div className="tw:flex tw:flex-col tw:items-center tw:justify-center tw:text-center tw:px-8 tw:mt-16">
            <p className="tw:text-gray-600 tw:mb-6">No forms found</p>

            {onRefresh && (
                <Button onClick={onRefresh} variant="secondary" size="default">
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
                        <path d="M21 3v5h-5" />
                        <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
                        <path d="M3 21v-5h5" />
                    </svg>
                    Refresh
                </Button>
            )}
        </div>
    )
}

export default EmptyState
